/* 🤖 this file was generated by svg-to-ts */
export const iconAtokenwallet: {
  name: 'atokenwallet';
  data: string;
} = {
  name: 'atokenwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0M8.9 24.49H6c-.24 0-.4-.26-.29-.47l10-20.01c.1-.19.37-.19.47 0l1.58 2.97c.05.09.05.21 0 .3L9.19 24.32c-.06.11-.17.18-.29.18zm9.81.04h-5.47c-.25 0-.4-.26-.29-.48l2.82-5.39c.12-.24.47-.23.58 0l2.66 5.39c.11.22-.05.47-.29.47zm7.29 0h-2.96c-.12 0-.24-.07-.29-.18l-4.87-9.72a.3.3 0 0 1 0-.29l1.47-2.99c.12-.24.47-.24.59 0l6.37 12.71c.11.22-.05.47-.29.47z"/></svg>`,
};
